import { useTranslate } from '../../../utils/translate'
import { useUnsplash } from '../UnsplashImageSearchContext'

export function UnsplashImageSearchFooter() {
  const t = useTranslate('interface', 'components.imageUploadSelectionComponent.UnsplashImageSearchPopover')
  const { selectedImage, isLoading, isDownloading, closeAndReset, handleApplySelection } = useUnsplash()

  return (
    <div className="unsplash-search-footer-buttons">
      <button className="unsplash-search-footer-buttons-cancel" onClick={closeAndReset} disabled={isDownloading}>
        {t('cancelButton.label')}
      </button>
      <button
        className="unsplash-search-footer-buttons-apply"
        onClick={handleApplySelection}
        disabled={!selectedImage || isLoading || isDownloading}
      >
        {isDownloading ? t('applyButton.loadingLabel') : t('applyButton.label')}
      </button>
    </div>
  )
}
